<template>
    <v-container fluid>
        <v-card class="px-5 py-3 br-15 w-100" elevation="0">
            <v-row>
                <v-col class="flex-grow-1">
                    <v-toolbar-title class="page-title"
                        >Importar BU</v-toolbar-title
                    >
                </v-col>

                <div class="d-flex py-3 px-4">
                    <v-btn
                        class="new-button"
                        color="primary"
                        @click="filtrar()"
                    >
                        <v-icon left>mdi-filter</v-icon> Filtrar
                    </v-btn>
                    <v-btn
                        class="ml-5 new-button"
                        color="primary"
                        @click="abrirImportacao()"
                    >
                        <v-icon left>mdi-import</v-icon> Importar
                    </v-btn>
                    <v-btn
                        class="ml-5 new-button"
                        color="primary"
                        @click="exportar()"
                    >
                        <v-icon left>mdi-microsoft-excel</v-icon> Exportar CSV
                    </v-btn>
                </div>
            </v-row>
        </v-card>

        <v-card class="px-5 py-5 br-15 w-100 mt-5" elevation="0">
            <v-data-table
                class="elevation-0 tabela"
                :headers="headers"
                :items="dados"
                :options.sync="pagination"
                :server-items-length="total"
                :footer-props="tableConfig"
                :header-props="{ sortIcon: 'mdi-chevron-down' }"
                multi-sort
            >
            </v-data-table>
        </v-card>
        <v-overlay :value="carregando" :z-index="300">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-dialog
            v-model="dialogo"
            scrollable
            persistent
            content-class="br-15"
            width="900"
            :z-index="200"
        >
            <v-card>
                <v-toolbar
                    elevation="0"
                    dark
                    class="primary-degrade white--text fix-flex"
                >
                    <v-toolbar-title> Importar BU</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        fab
                        width="24px"
                        height="24px"
                        elevation="0"
                        light
                        @click="dialogo = false"
                    >
                        <v-icon size="18px" color="primary">mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="pa-5">
                    <div class="instrucoes">
                        <h4 color="primary">
                            Para realizar a importação de BU, siga as instruções
                            abaixo.
                        </h4>
                        <ul>
                            <li>
                                A base utilizada para importação deve ser
                                parecido ao modelo de exportação. Todas as
                                linhas importadas serão consideradas para
                                <strong>Inserção.</strong>
                            </li>
                            <!-- Avisar que as os dados serão excluidos e sera considerado apenas os dados importados -->
                            <li>
                                Os dados existentes serão excluídos e será
                                considerado apenas os dados importados.
                            </li>

                            <li>
                                As seguintes colunas são obrigatórias:
                                <ul>
                                    <li>
                                        <strong>codigo_fornecedor</strong> -
                                        Código do fornecedor
                                    </li>
                                    <li>
                                        <strong>comprador</strong> - Nome do
                                        comprador
                                    </li>
                                    <li>
                                        <strong>analista</strong> - Nome do
                                        analista
                                    </li>
                                    <li>
                                        <strong>BU</strong> - Nome da BU
                                        (maiusculo)
                                    </li>
                                </ul>
                            </li>
                            <li>
                                Para indicar um fornecedor, deve ser utilizado o
                                Código do fornecedor na coluna
                                <strong>codigo_fornecedor</strong>. A coluna
                                <strong>fornecedor</strong> é para simples
                                conferência.
                            </li>
                        </ul>
                    </div>
                    <v-row>
                        <v-col>
                            <v-alert
                                v-if="erroImportacao"
                                type="error"
                                text
                                icon="mdi-close-circle"
                                class="justify-center"
                            >
                                <v-row align="center">
                                    <v-col class="grow py-0">
                                        {{ errosMensagem }}</v-col
                                    >
                                    <v-col class="shrink py-0">
                                        <v-btn
                                            v-if="errosImportacao"
                                            color="red"
                                            @click="dialogErro = true"
                                            small
                                            style="
                                                font-size: 16px;
                                                font-weight: 500;
                                            "
                                            >Exibir erros</v-btn
                                        >
                                    </v-col>
                                </v-row>
                            </v-alert>
                            <v-alert
                                v-if="sucessos.length > 0"
                                type="success"
                                text
                                icon="mdi-close-circle"
                                class="justify-center"
                            >
                                <v-row align="center">
                                    <v-col class="grow py-0"
                                        >As demais linhas foram inseridas com
                                        sucesso. Total de linhas inseridas:
                                        {{ sucessos.length }}</v-col
                                    >
                                </v-row>
                            </v-alert>
                        </v-col>
                    </v-row>
                    <v-form ref="fromInventario">
                        <v-row class="mt-5">
                            <v-col cols="12" class="pb-0">
                                <v-file-input
                                    label="Arquivo CSV"
                                    class="input-cinza"
                                    outlined
                                    dense
                                    v-model="arquivoCSV"
                                    accept=".csv"
                                    :rules="regra.csv"
                                ></v-file-input>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        class="new-button px-6 mb-3 mr-2"
                        @click="importar()"
                    >
                        <v-icon left>mdi-upload</v-icon>
                        Importar Arquivo
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            content-class="br-15"
            v-model="dialogErro"
            width="800"
            :z-index="400"
        >
            <v-card>
                <v-toolbar
                    elevation="0"
                    dark
                    class="error white--text fix-flex"
                >
                    <v-toolbar-title>
                        Erros durante a importação
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        fab
                        width="24px"
                        height="24px"
                        elevation="0"
                        light
                        @click="dialogErro = false"
                    >
                        <v-icon size="18px" color="error">mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="mt-4">
                    <v-data-table
                        :headers="headerErros"
                        class="elevation-0 tabela"
                        :items="errosImportacao"
                        :items-per-page="10"
                        :footer-props="tableConfig"
                        color="error"
                    ></v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <download-csv
                        :data="errosImportacao"
                        :labels="errosLabels"
                        name="erros_planejamento_ecommerce.csv"
                        delimiter=";"
                    >
                        <v-btn class="new-button px-4 mb-2" color="primary">
                            <v-icon class="mr-3">mdi-microsoft-excel</v-icon>
                            Exportar erros em CSV
                        </v-btn>
                    </download-csv>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
  
  
  <script>
export default {
    name: 'ImportarBU',

    data() {
        return {
            menuProps: {
                bottom: true,
                offsetY: true,
                contentClass: 'select-outline',
                transition: 'slide-y-transition',
            },

            listaCampos: {
                status: [],
            },
            carregando: false,
            dialogo: false,
            erroImportacao: false,
            errosImportacao: [],
            errosMensagem: '',
            sucessos: [],
            arquivoCSV: null,
            dialogErro: false,
            regra: {
                csv: [
                    (v) => !!v || 'Selecione um arquivo.',
                    (v) =>
                        (!!v && ['.csv', '.CSV'].includes(v.name.substr(-4))) ||
                        'O arquivo deve ser do tipo CSV.',
                ],
            },
            tableConfig: {
                itemsPerPageOptions: [5, 10, 15, 25, 50, 100],
                itemsPerPageText: 'Linhas por páginas',
                ofText: 'de',
                pageText: '{0}-{1} de {2}',
            },

            total: 0,
            pagination: {},

            headers: [
                {
                    text: 'Código Fornecedor',
                    value: 'codigo_fornecedor',
                    class: 'th-separador min-width-100',
                    align: 'center',
                },
                {
                    text: 'Fornecedor',
                    value: 'fornecedor',
                    class: 'th-separador min-width-100',
                    align: 'center',
                },
                {
                    text: 'Comprador',
                    value: 'comprador',
                    class: 'th-separador min-width-100',
                    align: 'center',
                },
                {
                    text: 'Analista',
                    value: 'analista',
                    class: 'th-separador min-width-100',
                    align: 'center',
                },
                {
                    text: 'BU',
                    value: 'bu',
                    class: 'th-separador min-width-100',
                    align: 'center',
                },
            ],
            headerErros: [
                { text: 'Descrição', value: 'msg', class: 'th-separador' },
                {
                    text: 'Linha',
                    value: 'linha',
                    align: 'center',
                    with: '100px',
                },
            ],
            errosLabels: {
                msg: 'Descrição',
                linha: 'Linha',
            },
        }
    },
    watch: {
        pagination: {
            handler() {
                this.filtrar()
            },
            deep: true,
        },
    },
    created() {
        // this.filtrar();
        // this.fnListaCampos()
    },
    methods: {
        abrirImportacao() {
            this.dialogo = true
        },
        async filtrar() {
            this.carregando = true
            this.dados = []
            const response = await this.$http().post(
                '/simulacao/gerencial/listar_bu',
                {
                    data: {
                        pagination: this.pagination,
                    },
                }
            )
            if (response.status == 200 && response.data) {
                // this.total =

                const dados = response.data
                this.dados = dados

                this.total = response.data[0].total
            }
            this.carregando = false
        },
        async exportar() {
            this.carregando = true

            var data = {}

            const response = await this.$http().post(
                '/simulacao/gerencial/exportar_bu',
                {
                    data: data,
                }
            )

            if (response.status == 200 && response.data.url) {  
                window.location = this.$http('baseURL') + response.data.url
            }else {
                this.$dialog.notify.error('Erro ao exportar BU', {
                    position: 'top-right',
                    timeout: 5000,
                })
            }


            this.carregando = false
        },
        async importar() {
            if (!this.$refs.fromInventario.validate()) return
            this.erroImportacao = false
            this.errosImportacao = []
            this.errosMensagem = ''

            this.carregando = true

            const formData = new FormData()

            formData.append('files', this.arquivoCSV)

            const response = await this.$http().post(
                '/simulacao/gerencial/importar_bu',
                formData
            )

            if (response.status == 200 && response.data.error == false) {
                this.dialogo = false
                this.$dialog.notify.success('BU importados com sucesso', {
                    position: 'top-right',
                    timeout: 5000,
                })
            } else {
                this.erroImportacao = true
                this.errosImportacao = response.data?.erros
                this.sucessos = response.data?.sucessos
                this.errosMensagem =
                    response.data.mensagem || 'Erro ao importar BU'
            }

            // console.log(response);
            this.carregando = false
        },
    },
}
</script>
  
  